export const privacyContent = `# Privacy Policy

Last updated: December 1, 2024

## 1. Introduction

Welcome to Quick Chef's Privacy Policy. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you use our mobile application.

## 2. Information We Collect

### 2.1 Personal Information
We collect several types of information, including:
- Email address (when you create an account)
- Profile information (name, profile picture)
- Authentication data from Google Sign-In
- Device information
- Usage data

### 2.2 App Usage Information
We automatically collect usage data when you use Quick Chef:
- Ingredients entered for recipe generation
- App feature usage patterns
- Device type and operating system
- Session duration and frequency
- Performance and error data

### 2.3 User-Generated Content
- Saved recipes
- Ratings
- Meal plans

## 3. How We Use Your Information

### 3.1 Primary Uses
We use your information to:
- Provide personalized recipe recommendations
- Improve our AI recipe generation system
- Remember your preferences and settings
- Authenticate your identity
- Provide customer support
- Send important updates about the app

### 3.2 AI and Machine Learning
- Recipe generation through Gemini Pro API
- Ingredient recognition and processing
- Personalization of recipe suggestions
- All AI processing is done in real-time and not stored

## 4. Data Storage and Security

### 4.1 Data Storage
- Personal information is stored securely in the cloud
- Ingredient lists are processed locally when possible
- Temporary data is cleared after each session
- Backup systems are encrypted and secure

### 4.2 Security Measures
We implement various security measures including:
- End-to-end encryption for data transmission
- Secure authentication protocols
- Regular security audits
- Automated threat detection
- Secure data backup systems

## 5. Data Sharing

### 5.1 Third-Party Services
We may share data with:
- Google Sign-In for authentication
- Gemini Pro API for recipe generation
- Analytics providers for app improvement

### 5.2 Legal Requirements
We may disclose information if:
- Required by law
- To protect our rights and safety
- To investigate potential violations
- To comply with legal process

## 6. User Rights and Controls

### 6.1 Your Rights
You have the right to:
- Access your personal data
- Correct inaccurate data
- Request data deletion
- Export your data

### 6.2 Account Settings
You can control:
- Saved recipe visibility
- Account deletion

## 7. Data Retention

### 7.1 Retention Period
- Account information: Until account deletion
- Usage data: Can be cleared by user
- Recipe history: Until manually cleared
- Device information: Duration of app installation

### 7.2 Data Deletion
- You can request account deletion at any time
- Certain data may be retained for legal purposes
- Anonymized data may be kept for analytics

## 8. Children's Privacy

- We do not knowingly collect data from children
- Parents can request data deletion

## 9. International Data Transfers

- Data may be processed in different countries
- We ensure appropriate safeguards are in place
- We comply with international data protection laws
- Data transfers follow standard contractual clauses

## 10. Cookie Policy

### 10.1 App Cookies
We use local storage and cookies to:
- Remember your preferences
- Maintain session information
- Improve app performance
- Track usage patterns

### 10.2 Third-Party Cookies
- Analytics providers may use cookies
- Authentication services use session cookies
- You can control cookie settings in your device

## 11. Changes to This Policy

- We may update this policy periodically
- Significant changes will be notified in-app
- Continued use implies acceptance of changes
- Previous versions will be archived

## 12. Contact Information

For privacy-related inquiries:
- Email: funroboticshere@gmail.com
- Website: www.quickchef.app/privacy

## 13. Compliance

Quick Chef complies with:
- GDPR (European Union)
- CCPA (California)
- PIPEDA (Canada)
- APP (Australia)
- Other

## 14. Additional Information

### 14.1 Analytics and Tracking
We use analytics tools to:
- Improve app functionality
- Understand user behavior
- Optimize performance
- Debug issues

### 14.2 Security Breach Procedures
In case of a data breach:
- Users will be notified promptly
- Authorities will be informed as required
- Remedial actions will be taken
- Investigation will be conducted

## 15. Acceptance of Terms

By using Quick Chef, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.

## 16. Questions and Concerns

- If you have any questions about this Privacy Policy or our practices, please contact us at funroboticshere@gmail.com.
`;